// eslint-disable-next-line complexity
export function getValueStyles(gaugeValue, threshold) {
    if (gaugeValue === null || gaugeValue === undefined || !threshold) {
        return {};
    }

    const valueStyles = {};

    if (gaugeValue > threshold.value && threshold.greaterThanColor) {
        valueStyles.color = threshold.greaterThanColor;
    }

    if (gaugeValue < threshold.value && threshold.lessThanColor) {
        valueStyles.color = threshold.lessThanColor;
    }

    if (gaugeValue === threshold.value && threshold.equalToColor) {
        valueStyles.color = threshold.equalToColor;
    }

    return valueStyles;
}
